import React from "react";

const SpinnerFull = () => {
  return (
    <>
       <div id="cover-spin"></div>
    </>
  );
};

export default SpinnerFull;
